if (!customElements.get('dkt-odyssey')) customElements.define('dkt-odyssey', class extends HTMLElement {
  connectedCallback() {
    this.abort?.abort(); this.abort = new AbortController();
    this.worlds = [...this.querySelectorAll('.dkto__world')];
    this.pin = this.querySelector('.dkto__pin');
    this.motion = matchMedia('(prefers-reduced-motion: reduce)');
    this.small = matchMedia('(max-width: 749px)');
    const options = {signal:this.abort.signal};
    this.queue = () => { if (!this.frame) this.frame=requestAnimationFrame(()=>{this.frame=0;this.update();}); };
    ['scroll','resize','pageshow'].forEach(name=>window.addEventListener(name,this.queue,{...options,passive:true}));
    this.motion.addEventListener('change',()=>this.configure(),options);
    this.small.addEventListener('change',()=>this.configure(),options);
    this.worlds.forEach((world,index)=>{
      const video=world.querySelector('video');
      video.addEventListener('loadeddata',()=>{
        if (!this.allowed()) return;
        world.setAttribute('data-ready','');
        if(index===0){clearTimeout(this.timeout);this.setAttribute('data-enhanced','');}
        this.queue();
      },options);
      video.addEventListener('seeked',()=>this.seek(video),options);
      video.addEventListener('error',()=>{world.removeAttribute('data-ready');if(index===0)this.staticView();},options);
    });
    this.configure();
  }
  allowed(){return !this.motion.matches && !navigator.connection?.saveData;}
  staticView(){
    clearTimeout(this.timeout);this.removeAttribute('data-enhanced');
    this.worlds.forEach(world=>{
      world.removeAttribute('data-visible');world.removeAttribute('data-ready');world.removeAttribute('aria-hidden');world.inert=false;
      world.style.removeProperty('clip-path');world.style.removeProperty('z-index');
      ['--local','--camera','--copy','--copy-y'].forEach(p=>world.style.removeProperty(p));
      world.querySelector('video').pause();world.querySelector('.dkto__copy').inert=false;
    });
  }
  configure(){
    this.staticView();
    this.worlds.forEach(world=>{const v=world.querySelector('video');v.removeAttribute('src');v.load();});
    if(!this.allowed())return;
    this.load(0);this.timeout=setTimeout(()=>{if(!this.hasAttribute('data-enhanced'))this.staticView();},12000);
  }
  load(index){
    const world=this.worlds[index];if(!world||!this.allowed())return;
    const v=world.querySelector('video'),src=this.small.matches?v.dataset.mobile:v.dataset.desktop;
    if(v.getAttribute('src')!==src){v.src=src;v.preload='auto';v.load();}
  }
  update(){
    if(!this.hasAttribute('data-enhanced')||!this.allowed())return;
    const clamp=n=>Math.min(1,Math.max(0,n));
    const p=clamp(((parseFloat(getComputedStyle(this.pin).top)||0)-this.getBoundingClientRect().top)/Math.max(1,this.offsetHeight-this.pin.offsetHeight));
    const position=p*3.82,index=Math.min(3,Math.floor(position)),local=position-index;
    const mix=index<3?clamp((local-.72)/.28):0;
    const ease=mix*mix*(3-2*mix);
    this.style.setProperty('--progress',p.toFixed(4));
    this.querySelector('[data-odyssey-index]').textContent=String(index+1).padStart(2,'0');
    this.load(index);if(local>.3)this.load(index+1);
    this.worlds.forEach((world,i)=>{
      const incoming=i===index+1&&mix>0,active=i===index,visible=active||incoming;
      world.toggleAttribute('data-visible',visible);world.inert=!active||mix>.25;world.setAttribute('aria-hidden',String(!active||mix>.25));
      if(!visible)return;
      const sceneProgress=active?clamp(local/.72):0;
      world.style.zIndex=incoming?'2':'1';
      world.style.clipPath=incoming?`inset(${(1-ease)*50}% ${(1-ease)*36}% round ${(1-ease)*22}px)`:'inset(0)';
      world.style.setProperty('--local',sceneProgress.toFixed(4));
      world.style.setProperty('--camera',(incoming?1.16-(ease*.16):1+mix*.16).toFixed(4));
      const copy=incoming?0:(index===0?1:clamp(local/.12))*(1-clamp((local-.54)/.18));
      world.style.setProperty('--copy',copy.toFixed(4));world.style.setProperty('--copy-y',(-40*(1-copy)).toFixed(2));
      const v=world.querySelector('video');v.dktTarget=sceneProgress*Math.max(0,(v.duration||0)-.04);this.seek(v);
      world.querySelector('.dkto__copy').inert=copy<.15||incoming;
    });
    // Leave the final invitation visible while the visitor exits the fixed scene.
    if(index===3){const last=this.worlds[3];const entrance=clamp(local/.12);last.style.setProperty('--copy',entrance.toFixed(4));last.style.setProperty('--copy-y',String(25*(1-entrance)));last.querySelector('.dkto__copy').inert=entrance<.15;}
  }
  seek(video){
    if(!this.allowed()||!this.hasAttribute('data-enhanced')||video.readyState<1||video.seeking||!Number.isFinite(video.dktTarget))return;
    if(Math.abs(video.currentTime-video.dktTarget)>.03)video.currentTime=video.dktTarget;
  }
  disconnectedCallback(){this.abort?.abort();cancelAnimationFrame(this.frame);this.staticView();}
});
